import { useEffect, useRef, useState } from "react"
import { throttle } from "lodash-es"

export const useResize = (
    callback: () => void,
    deps: any[] = [null],
    throttle = 100
) => {
    const timer = useRef(NaN)
    useEffect(() => {
        callback()
        const listener = () => {
            window.clearTimeout(timer.current)
            callback()
            timer.current = window.setTimeout(() => {
                callback()
            }, throttle)
        }
        window.addEventListener("resize", listener)
        return () => window.removeEventListener("resize", listener)
    }, deps)
}

export const useResizeEffect = (
    callback: () => void,
    deps: any[] = [null],
    throttleDuration = 100
) => {
    const [fontSize, setFontSize] = useState("")
    useEffect(() => {
        const listener = throttle(() => {
            setFontSize(`${window.innerWidth}-${window.innerHeight}`)
        }, throttleDuration)
        window.addEventListener("resize", listener)
        return () => window.removeEventListener("resize", listener)
    }, [])
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(callback, [...deps, fontSize])
}
